import { Button, ButtonTheme } from '@apply/components';
import { IDashboardDrawBudget } from '@apply/api/src/api/DrawApi';
import { DrawAddressLink } from './components/DrawAddressLink';
import { useAuthentication } from '../../../../../../../Login/hooks/useAuthentication';
import { useAuthenticationStore } from '../../../../../../../state/authenticationStore';

interface BlockedDrawCardProps {
    dashboardDrawBudget: IDashboardDrawBudget;
}

export const BlockedDrawCard: React.FC<BlockedDrawCardProps> = ({ dashboardDrawBudget }) => {
    const { authentication } = useAuthentication();
    const selectedAuthorizedDrawUserEntity = useAuthenticationStore((s) => s.selectedEntity);
    const pillText = (): string => {
        const { isApproved, isEquityMet, isBudgetMaxed, canGCAddDraw } = dashboardDrawBudget;

        if (authentication?.user.isGeneralContractor && selectedAuthorizedDrawUserEntity != null && !canGCAddDraw)
            return 'Pending Authorization';

        if (!isApproved) return 'Waiting for Approval';

        if (!isEquityMet) return 'Equity Not Met';

        if (isBudgetMaxed) return '100% Drawn';

        return 'Unknown Error';
    };

    return (
        <div className='row draw-blocked-container'>
            <DrawAddressLink dashboardDrawBudget={dashboardDrawBudget} />
            <div className='draw-blocked-container-status'>
                <div className='panelBadge'>
                    <Button
                        id='blockedDrawButton'
                        theme={ButtonTheme.Secondary}
                        width='160px'
                        disabled={true}
                    >
                        {pillText()}
                    </Button>
                </div>
            </div>
        </div>
    );
};
